<template>
  <v-dialog v-model="dialogEnroll" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable persistent>
    <v-card tile v-if="modulo">
      <v-toolbar flat dark color="primary" class="max-height">
        <v-toolbar-title v-if="modulo && modulo.modulo"> Modulo: {{ modulo.modulo.nombre }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeDialogEnroll"> <v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title class="pb-0">
            <v-select
              v-model="from_module"
              :items="incribedFrom"
              item-text="course_name"
              return-object
              label="Inscribir desde"
              outlined
              dense
              hide-details
              background-color="yellow lighten-4"></v-select>
          </v-card-title>
          <v-card-text>
            <p v-html="datamsg"></p>
            <v-skeleton-loader
              :loading="!sinMoodle.length && !regulares.length && !inscritosByModule.length"
              transition="scale-transition"
              height="300"
              type="table">
              <v-row>
                <!-- -------------estudiantes preinscritos------------- -->
                <v-col cols="12" v-if="preinscritos.length > 0">
                  <p class="text-center title h3">Estudiantes Preinscritos en el sistema : {{ preinscritos.length }}</p>
                  <v-data-table
                    :headers="headers"
                    :items="preinscritos"
                    sort-by="full_name"
                    :itemsPerPage="-1"
                    class="elevation-10 red lighten-4"
                    :search="search_preinscritos">
                    <template v-slot:top>
                      <v-text-field
                        outlined
                        dense
                        v-model="search_preinscritos"
                        label="Buscar en la lista"
                        class="mx-4 mt-1"></v-text-field>
                    </template>
                    <template #[`item.full_name`]="{ item }">
                      {{ item.estudiante.nombres }} {{ item.estudiante.pri_apellido }}
                      {{ item.estudiante.seg_apellido }}
                    </template>
                  </v-data-table>
                </v-col>
                <!-- ---------------- Estudiantes no existentes en moodle Moodle---------- -->
                <v-col cols="12" v-if="sinMoodle.length > 0">
                  <v-card>
                    <v-card-title class="py-1">
                      <p class="text-center title h3">Estudiantes No Existentes en Moodle: {{ sinMoodle.length }}</p>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="orange"
                            v-bind="attrs"
                            v-on="on"
                            class="ma-2"
                            outlined
                            rounded
                            @click="registerInMoodle">
                            <v-icon class="ma-2">mdi-content-save-all</v-icon> Crear Automaticamente Usuarios En Moodle
                          </v-btn>
                        </template>
                        Se Registraran a los siguientes Estudiantes en la plataforma Moodle
                      </v-tooltip>
                    </v-card-title>

                    <v-data-table
                      show-select
                      v-model="selected"
                      :headers="headers"
                      :items="sinMoodle"
                      sort-by="full_name"
                      :itemsPerPage="-1"
                      class="elevation-10"
                      :search="search_no_moodle">
                      <template v-slot:top>
                        <v-text-field
                          outlined
                          dense
                          v-model="search_no_moodle"
                          label="Buscar en la lista"
                          class="mx-4 mt-1"></v-text-field>
                      </template>
                      <template #[`item.full_name`]="{ item }">
                        {{ item.estudiante.nombres }} {{ item.estudiante?.pri_apellido }}
                        {{ item.estudiante?.seg_apellido }}
                      </template>
                      <template #[`item.estado_ins`]="{ item }">
                        {{ estadosInscripcion[item.estado_ins]?.toUpperCase() }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
                <!-- -----------estudiantes q se pueden inscribir al modulo--------------- -->
                <v-col cols="12" v-if="!modulo.course_id">
                  <p class="px-4 red font-weight-thin white--text text-justify h4 rounded">
                    Modulo no asociado con curso de moodle, los alumnos seran inscritos solo en el sistema y no en
                    moodle
                  </p>
                </v-col>
                <v-col cols="12" v-if="regulares.length > 0">
                  <v-card>
                    <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
                      <p class="text-center title h3">Estudiantes Regulares para el modulo : {{ regulares.length }}</p>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            class="ma-2"
                            outlined
                            rounded
                            @click="saveEnroll">
                            <v-icon class="ma-2">mdi-content-save-all</v-icon> Realizar inscripcion A Modulo
                          </v-btn>
                        </template>
                        Los Siguientes Estudiantes seran inscritos al siguiente modulo
                        <strong v-if="modulo && modulo.modulo">{{ modulo.modulo.nombre }} </strong>
                      </v-tooltip>
                    </v-card-title>
                    <v-data-table
                      v-model="selectedEnroll"
                      :headers="headers"
                      :items="regulares"
                      sort-by="full_name"
                      show-select
                      :itemsPerPage="-1"
                      class="elevation-10"
                      :search="search_regulares">
                      <template v-slot:top>
                        <v-text-field
                          outlined
                          dense
                          v-model="search_regulares"
                          label="Buscar en la lista"
                          class="mx-4 mt-1"></v-text-field>
                      </template>
                      <template #[`item.full_name`]="{ item }">
                        {{ item.estudiante.nombres }} {{ item.estudiante?.pri_apellido }}
                        {{ item.estudiante?.seg_apellido }}
                      </template>
                      <template v-slot:[`item.status`]="{ item }">
                        <!-- <v-simple-checkbox v-model="item.status"></v-simple-checkbox> -->
                        <v-switch v-model="activos" color="primary" :label="item.status" :value="item"></v-switch>
                      </template>
                      <template #[`item.estado_ins`]="{ item }">
                        {{ estadosInscripcion[item.estado_ins]?.toUpperCase() }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
                <!-- -------------inscritos al Module------------- -->
                <v-col cols="12" v-if="inscritosByModule.length > 0">
                  <p class="text-center title h3">
                    Estudiantes Ya Inscritos en este modulo : {{ inscritosByModule.length }}
                  </p>
                  <v-data-table
                    :headers="
                      headers.filter((h) => {
                        return h.text !== 'Estado Inscripcion';
                      })
                    "
                    :items="inscritosByModule"
                    sort-by="full_name"
                    :itemsPerPage="-1"
                    class="elevation-10"
                    :search="search_inscritos">
                    <template v-slot:top>
                      <v-text-field
                        outlined
                        dense
                        v-model="search_inscritos"
                        label="Buscar en la lista"
                        class="mx-4 mt-1"></v-text-field>
                    </template>
                    <template #[`item.full_name`]="{ item }">
                      {{ item.estudiante.nombres }} {{ item.estudiante?.primer_apellido }}
                      {{ item.estudiante?.segundo_apellido }}
                    </template>
                  </v-data-table>
                </v-col>
                <!-- -------------Esduantes descartados en el modulo anterior------------- -->
                <v-col cols="12" v-if="descartados.length > 0">
                  <p class="text-center title h3">
                    Estudiantes Que Congelaron/Abandonaron en Modulo anterior : {{ descartados.length }}
                  </p>
                  <v-data-table
                    :headers="headers"
                    :items="descartados"
                    sort-by="full_name"
                    :itemsPerPage="-1"
                    class="elevation-10"
                    :search="search_descartados">
                    <template v-slot:top>
                      <v-text-field
                        outlined
                        dense
                        v-model="search_descartados"
                        label="Buscar en la lista"
                        class="mx-4 mt-1"></v-text-field>
                    </template>

                    <template #[`item.full_name`]="{ item }">
                      {{ item.estudiante.nombres }} {{ item.estudiante.pri_apellido }}
                      {{ item.estudiante.seg_apellido }}
                    </template>
                  </v-data-table>
                </v-col>
                <!-- -------------suspended en moodle------------- -->
                <v-col cols="12" v-if="suspended.length > 0">
                  <p class="text-center title h3">
                    Estudiantes Suspendidos en la plataforma moodle : {{ suspended.length }}
                  </p>
                  <v-data-table
                    :headers="headers"
                    :items="suspended"
                    sort-by="full_name"
                    :itemsPerPage="-1"
                    class="elevation-10"
                    :search="search_supendidos">
                    <template v-slot:top>
                      <v-text-field
                        outlined
                        dense
                        v-model="search_supendidos"
                        label="Buscar en la lista"
                        class="mx-4 mt-1"></v-text-field>
                    </template>

                    <template #[`item.full_name`]="{ item }">
                      {{ item.estudiante.nombres }} {{ item.estudiante.pri_apellido }}
                      {{ item.estudiante.seg_apellido }}
                    </template>
                    <template #[`item.estado_ins`]="{ item }">
                      {{ estadosInscripcion[item.estado_ins]?.toUpperCase() }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="ma-2" outlined rounded @click="closeDialogEnroll">
          <v-icon>mdi-close</v-icon> Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import xaxios from '@/xaxios';
// import { parseInscripcionEstado } from '@/components/Utils.js';

export default {
  props: ['programa', 'plataformas'],
  data() {
    return {
      modulo: null,
      search_no_moodle: '',
      search_regulares: '',
      search_inscritos: '',
      search_supendidos: '',
      search_descartados: '',
      search_preinscritos: '',
      selected: [],
      activos: [],
      selectedEnroll: [],
      api_rest: process.env.VUE_APP_API_REST,
      //api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
      dialogEnroll: false,
      regulares: [],
      suspended: [],
      sinMoodle: [],
      descartados: [],
      preinscritos: [],
      inscritosByModule: [],
      inscritosByPrograma: [],
      headers: [
        { text: 'Id Inscripcion', value: 'inscripcion_id' },
        { text: 'Estado Inscripcion', value: 'estado_ins' },
        { text: 'Nombre Completo', value: 'full_name' },
        { text: 'N° Doc', value: 'estudiante.numero_documento' },
        { text: 'Moodle Username', value: 'estudiante.usuario_moodle' },
        { text: 'Email', value: 'estudiante.email' },
        { text: 'Telefono', value: 'estudiante.telefono1' },
        // { text: 'Estado', value: 'status' },
        // { text: '', value: 'estado' },
      ],
      from_module: null,
      incribedFrom: [],

      datamsg: '',
      plataforma: {},
      msgerr: '',
      estadosInscripcion: {
        0: 'Preinscrito',
        1: 'Inscrito',
        2: 'Retirado',
        3: 'Cambiado',
        4: 'Congelado',
        5: 'Pagado',
      },
    };
  },
  watch: {
    dialogEnroll(val) {
      return val || this.closeDialogEnroll();
    },
    async from_module(value) {
      if (this.modulo) {
        this.inscritosByModule = [];
        this.selected = [];
        this.regulares = [];
        this.suspended = [];
        this.preinscritos = [];
        this.sinMoodle = [];
        this.descartados = [];
        let estudiantes = [];
        if (value && value.id) {
          //obtiene los inscritos del modulo anterior de donde se traen los inscritos
          let inscribedBeforeModule = await this.getInscribed(value.id);
          inscribedBeforeModule = inscribedBeforeModule.inscripciones ? inscribedBeforeModule.inscripciones : [];

          // obtiene los inscritos del  presente modulo
          let inscribed = await this.getInscribed(this.modulo.id);
          inscribed = inscribed.inscripciones ? inscribed.inscripciones : [];

          inscribed.forEach((currentModule) => {
            inscribedBeforeModule = inscribedBeforeModule.filter(
              (beforeModule) => beforeModule.inscripcion_id != currentModule.inscripcion_id,
            );
          });

          this.msgerr = '';
          if (!this.plataforma.id) {
            this.plataformaprograma();
          }

          this.inscritosByModule = inscribed;
          // consultar si cada student existe en moodle, si => regulares[], no => sinMoodle[] , si suspendido => suspended[]
          // window.console.log(this.programa.plataforma_id && !!this.modulo.course_id, !!this.programa.plataforma_id, !!this.modulo.course_id);
          inscribedBeforeModule.forEach(async (student) => {
            // if (this.programa.plataforma_id && this.modulo.course_id) {
            // let url = `${this.plataforma.direccion}/esam/user/uname/${student.estudiante.usuario_moodle}`;
            let url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
              this.plataforma.id
            }/user/uname/${student.estudiante.usuario_moodle}`;
            await xaxios
              .get(url)
              .then(({ data }) => {
                window.console.log('from_module', data);
                // FIXME: REVISAR los estados de inscripciones...
                if (student.estado_inscripcion == 0) this.regulares.push(student);
                if (data.suspended) this.suspended.push(student);
              })
              .catch(() => this.sinMoodle.push(student));

            // } else {
            //   this.descartados.push(student);
            // }
          });
        } else {
          estudiantes = this.inscritosByPrograma;

          let inscribed = await this.getInscribed(this.modulo.id);
          inscribed = inscribed.inscripciones ? inscribed.inscripciones : [];

          //  filtra solo a los estudiantes que aun no estan inscritos en el modulo
          inscribed.forEach((std) => (estudiantes = estudiantes.filter((student) => student.id != std.inscripcion_id)));

          this.preinscritos = estudiantes.filter((ins) => ins.estado_ins === 0);
          estudiantes = estudiantes.filter((ins) => ins.estado_ins != 0);

          this.inscritosByModule = inscribed;
          estudiantes.forEach(async (student) => {
            // const url = `${this.plataforma.direccion}/esam/user/uname/${student.estudiante.usuario_moodle}`;
            const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
              this.plataforma.id
            }/user/uname/${student.estudiante.usuario_moodle}`;
            /* si el modulo tiene plataforma y curso entonces consultar si cada student existe en moodle, si => regulares[], no => sinMoodle[] , si suspendido => suspended[] */
            await xaxios
              .get(url)
              .then(({ data }) => {
                if (data.suspended) this.suspended.push(student);
                this.regulares.push(student);
              }) // TODO: verificas sis estan suspendidos
              .catch(() => this.sinMoodle.push(student));
          });
        }
      }
    },
  },
  methods: {
    concatenar(...args) {
      return args.filter((arg) => arg).join(' ');
    },
    showThisView(modulos, modulo, enrollByModule) {
      // window.console.log(enrollByModule);
      this.modulo = modulo;
      this.inscritosByPrograma = enrollByModule.map((std) => {
        std.inscripcion_id = std.id;
        std.estudiante.numero_documento = std.estudiante.num_doc;
        return std;
      });
      this.incribedFrom = modulos.filter((m) => m.id !== modulo.id && m.inscritos > 0);
      this.incribedFrom.unshift({ id: 0, course_name: 'PROGRAMA: LISTA DE ESTUDIANTES' });
      this.from_module = this.incribedFrom[0];
      this.dialogEnroll = true;
      this.plataformaprograma();
    },
    async registerInMoodle() {
      this.msgerr = '';
      if (!this.plataforma.id) {
        this.plataformaprograma();
      }
      if (this.selected.length == 0)
        return this.$root.$notify.show(`Debe Seleccionar Estudiantes de la Lista`, {
          color: 'primary',
          y: 'bottom',
          x: 'left',
        });

      this.selected.forEach((inscripcion) => {
        let estudiante = inscripcion.estudiante;
        let userForm = {
          email: estudiante.email,
          firstname: estudiante.nombres,
          lastname: this.concatenar(estudiante?.pri_apellido, estudiante?.seg_apellido),
          password: estudiante.clave_moodle,
          phone1: estudiante.telefono1,
          username: estudiante.usuario_moodle,
        };
        // registra al estudiante al moodle, si ok => regulares.push() else => sinMoodle => sinMoodle.push()
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.plataforma.id
        }/user`;
        xaxios
          .post(url, userForm)
          .then(({ data }) => {
            this.$root.$notify.show(`${data.result} Usuario Registrado en Moodle`, { color: 'success', y: 'top' });
            this.regulares.push(inscripcion);
            this.selected = this.selected.filter((item) => item !== inscripcion);
            this.sinMoodle = this.sinMoodle.filter((item) => item !== inscripcion);
          })
          .catch((e) => {
            if (e.response && e.response.data) {
              // window.console.log('errrrr',e.response);
              const d = e.response.data.error;
              this.$root.$notify.show(`ERROR: Usuario ${userForm.firstname} ${userForm.lastname} [${d}]`, {
                color: 'red',
                y: 'top',
              });
            } else {
              this.$root.$notify.show(`ERROR: Usuario ${userForm.firstname} ${userForm.lastname}`, {
                color: 'red',
                y: 'top',
              });
            }
          });
      });
    },

    async saveEnroll() {
      this.msgerr = '';
      if (!this.plataforma.id) {
        this.plataformaprograma();
      }
      if (this.selectedEnroll.length == 0)
        return this.$root.$notify.show(`Debe Seleccionar Estudiantes de la Lista`, {
          color: 'primary',
          y: 'bottom',
          x: 'left',
        });
      if (await this.$root.$confirm.open('Realizar Inscripcion', 'Estas seguro?', { color: 'orange' })) {
        let url = `${this.api_rest}/esam/inscripcion/modulo/student`;
        // inscribimos todos los regulares en el dataTable
        this.selectedEnroll.forEach((inscripcion) => {
          let { estudiante } = inscripcion;
          let formData = {
            inscripcion_id: inscripcion.inscripcion_id,
            programa_id: this.programa.id,
            programa_modulo_id: this.modulo.id, // if(0 || 1 ) INSCRIPCION = 0, PROGRAMADO = 1, EN DESARROLLO = 2, POSTERGADO = 3, CONCLUIDO = 4,
            estudiante_id: estudiante.id,
            username: estudiante.usuario_moodle,
            observacion: '',
            // estado_in_moodle: inscripcion.can_access
          };

          window.console.log('>>>', formData);

          xaxios
            .post(url, formData)
            .then(({ data }) => {
              this.selectedEnroll = this.selected.filter((item) => item !== inscripcion);
              this.modulo.inscritos++;
              this.$emit('increaseEnroll', this.modulo);
              this.inscritosByModule.push(inscripcion);
              this.regulares = this.regulares.filter((item) => item !== inscripcion);
              // si asociado entonces inscribe en moodle
              if (this.modulo.course_id) {
                const url_moodle = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(
                  /\/$/,
                  '',
                )}/plataformas/${this.plataforma.id}/enrolment`;
                // course_id ahora es el id del modulo
                const formEnroll = { username: estudiante.usuario_moodle, course_id: this.modulo.course_id, user_role: 5 };
                xaxios
                  .post(url_moodle, formEnroll)
                  .then(() =>
                    this.$root.$notify.show(data.Message + 'Estudiante Inscrito en Sistema y Moodle', {
                      color: 'success',
                      y: 'top',
                      x: 'right',
                    }),
                  )
                  .catch(({ response }) => {
                    this.$root.$notify.show(`${response.data.error} en MOODLE`, {
                      color: 'blue',
                      y: 'bottom',
                      x: 'left',
                    });
                  });
              }
            })
            .catch(({ response: { data } }) => {
              this.$root.$notify.show(`${data.error}`, { color: 'red', y: 'top' });
            });
        });
      }
    },
    getInscribed(id) {
      const url = `${this.api_rest}/esam/inscripcion/modulo/id/${id}`; // inscritos al modulo
      // window.console.log(url);
      return xaxios
        .get(url)
        .then(({ data }) => data)
        .catch(() => []);
    },
    closeDialogEnroll() {
      this.dialogEnroll = false;
      this.modulo = null;
      this.from_module = null;
      this.selected = [];
      this.regulares = [];
      this.suspended = [];
      this.sinMoodle = [];
      this.descartados = [];
      this.inscritosByModule = [];
      this.inscritosByPrograma = [];
      // ----------------
      this.incribedFrom = [];
      this.activos = [];
      this.selectedEnroll = [];
      this.preinscritos = [];
      this.search_no_moodle = '';
      this.search_regulares = '';
      this.search_inscritos = '';
      this.search_descartados = '';
      this.search_supendidos = '';
      this.search_preinscritos = '';
    },

    plataformaprograma() {
      let plataforma_id = this.programa.plataforma_id;
      this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
      this.datamsg = this.plataforma
        ? `<b>Plataforma</b>: ${this.plataforma.nombre}<br/><b>Servicio</b>: ${this.plataforma.direccion}`
        : 'No se ha definido la plataforma';
    },
  },
};
</script>
<style>
.max-height {
  max-height: 4.5em;
}
</style>